export default "__VITE_ASSET__e87941ad__"